<template>
  <div id="app">
    <Header/>
    <Menu/>
    <router-view/>
  </div>
</template>
<script>
import Header from '@/GlobalComponents/header'
import Menu from '@/GlobalComponents/menu'
export default {
    components: {
        Header,
        Menu
    }
}
</script>

<style lang="scss">
  @import "../style/base.scss";
  @import "../style/menu.scss";
  @import "../style/list.scss";
</style>
